import React, { Suspense } from "react";
import { LoadingSpinner } from "src/components/ui/loading-spinner";

const NotionIntegration = React.lazy(() => import("./NotionIntegration"));

interface NotionIntegrationProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function NotionIntegrationLazy(props: NotionIntegrationProps) {
  return (
    <Suspense fallback={<div className="flex justify-center p-4"><LoadingSpinner /></div>}>
      <NotionIntegration {...props} />
    </Suspense>
  );
}